export default "__VITE_ASSET__y73t6gWz__"